var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 625",
    d: "M-.019 2a.48.48 0 0 1-.339-.14.479.479 0 0 1 0-.679l1.537-1.54a.481.481 0 0 1 .68 0 .479.479 0 0 1 0 .679L.321 1.859A.48.48 0 0 1-.019 2z",
    transform: "translate(4.5 20)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 625",
    d: "M1.519 2a.48.48 0 0 0 .34-.819L.321-.359a.481.481 0 0 0-.68 0 .479.479 0 0 0 0 .679l1.538 1.54a.48.48 0 0 0 .34.14z",
    transform: "translate(18 20)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 624",
    d: "M23.02.5H-.02A.49.49 0 0 1-.5 0a.49.49 0 0 1 .48-.5h23.04a.49.49 0 0 1 .48.5.49.49 0 0 1-.48.5z",
    transform: "translate(.5 12)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29071",
    d: "M-17741.828-22574.248c-.451-.477-.461-.795-1.846-.795a2.145 2.145 0 0 0-2.15 2.316v7.684",
    transform: "translate(17747.84 22577.543)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17994",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h3.222a2 2 0 0 1 2 2v2.815H0V2a2 2 0 0 1 2-2z",
    style: {
      stroke: "none"
    },
    transform: "rotate(-45 7.661 -1.06)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 .5h3.222a1.5 1.5 0 0 1 1.5 1.5v2.315H.5V2A1.5 1.5 0 0 1 2 .5z",
    style: {
      fill: "none"
    },
    transform: "rotate(-45 7.661 -1.06)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 11",
    d: "M2.088 2.759a.8.8 0 1 1 .8.8.8.8 0 0 1-.8-.8zM0 2.408a.8.8 0 1 1 .8.8.8.8 0 0 1-.8-.8zM1.6.8a.8.8 0 1 1 .8.8.8.8 0 0 1-.8-.8z",
    transform: "translate(8.308 5.431)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18078",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21v7.5A1.5 1.5 0 0 1 19.5 9h-18A1.5 1.5 0 0 1 0 7.5V0z",
    style: {
      stroke: "none"
    },
    transform: "translate(1.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h20v7a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-7h0z",
    style: {
      fill: "none"
    },
    transform: "translate(1.5 11.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.3d149b7f93169a98f14c03e4291a89a5.svg";
export { ForwardRef as ReactComponent };